function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="42" height="42" viewBox="0 0 32 32" preserveAspectRatio="xMinYMax meet" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="fff" fill="#FFF"><path d="M11 1.571a9.429 9.429 0 1 1 0 18.858A9.429 9.429 0 0 1 11 1.57zM11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11A11 11 0 0 0 11 0z" /><path d="M11 6.325L9.892 7.433l2.774 2.781H6.325v1.572h6.34l-2.773 2.781L11 15.675 15.675 11z" /></g></svg>;
});


// WEBPACK FOOTER //
// ./src/images/circle-arrow-right.svg